import React, { useContext, useEffect, useMemo } from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { BoxClass, NodeById } from '../../../helper/classes'
import { Button, UL } from '@blueprintjs/core'
import { GlobalContext, globalOnDemandVars } from '../../../helper/context'
import { truncateDefault, undoManager } from '../../../helper/functions'
import { useIsPixelMode } from '../../../helper/hooks'
import { useTranslation } from 'react-i18next'

function LastClosedAddOn ({ onNewPage, setPath }) {
  const contextValue = useContext(GlobalContext)
  const isPixelMode = useIsPixelMode()
  const { t } = useTranslation()

  const rawLastClosedList = useMemo(() => (isPixelMode ? contextValue.lastClosedListForPixelMode : contextValue.lastClosedList), [contextValue.lastClosedList, contextValue.lastClosedListForPixelMode, isPixelMode])
  const lastClosedList = useMemo(() => (rawLastClosedList.map((nodeId) => (new NodeById(nodeId)))), [rawLastClosedList])

  // useEffect(() => {
  //   console.tron.display({
  //     name: 'LastClosedAddOn',
  //     preview: isPixelMode,
  //     value: {
  //       isPixelMode,
  //       currentList: lastClosedList,
  //       lastClosedListForPixelMode: contextValue.lastClosedListForPixelMode,
  //       lastClosedList: contextValue.lastClosedList
  //     }
  //     // , important: true
  //   })
  // }, [contextValue.lastClosedList, contextValue.lastClosedListForPixelMode, isPixelMode, lastClosedList])

  const result = useMemo(() => ((
    <div className={isPixelMode ? 'letItBePixel' : ''}>
      { lastClosedList.length ? null : <div css={css`text-align: center;`}><br /><br />{t('Nothing Here')}</div> }
      <div css={css`display: flex; flex-wrap: wrap; max-height: 160px;
& > * {
  flex-grow: 1;
  flex-basis: 150px;
}
`}>
        {lastClosedList.map((node) => {
          const titleFound = node.getTitle(globalOnDemandVars.isPixelMode())
          return (<div key={node.id}><Button icon={'dot'} title={titleFound || ''} disabled={titleFound === false} minimal onClick={() => {
            if (onNewPage) {
              setPath({ node })
            } else {
              node.onClick(globalOnDemandVars.isPixelMode())
            }
          }}>{titleFound === false ? t('Deleted') : (titleFound ? truncateDefault(titleFound, true, true) : <span css={css`color: var(--gray6);`}>Blank</span>)}</Button></div>)
        })}
      </div>
    </div>
  )
  ), [isPixelMode, lastClosedList, onNewPage, setPath, t])
  return result
}

// function LastClosedAddOn (props) {
//   return (
//     <GlobalContext.Consumer>
//       {({ lastClosedList }) => (<InnerLastClosedAddOn
//         {...props} contextValue={{ lastClosedList }}
//       />)}
//     </GlobalContext.Consumer>
//   )
// }

const LastClosedAddOnBoxClass = new BoxClass(LastClosedAddOn, 'Last Closed Windows', null, 1, { order: 3, onlyForTheseLocations: ['/organizing', '/pixel'] })

export default LastClosedAddOnBoxClass

export { LastClosedAddOn }
